import { type UserRegistrationProps } from './UserRegistration'

export const defaultProps: UserRegistrationProps = {
  theme: 'light',
  buttonTestId: 'user_registration_btn',
  attributes: {},
  submitButtonText: 'Sign Up',
  privacyPolicyLink: 'https://teambeachbody.com/shop/us/wcs/privacy?locale=en_US',
  termsAndConditionsLink: 'https://teambeachbody.com/shop/us/wcs/termsOfUse?locale=en_us',
}
